var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "700" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s(_vm.form.id ? "edit" : "add"))]),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.form.id
                          ? "Editar Formacion Academica"
                          : "Crear Formacion Academica"
                      ) +
                      "\n        "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.estudios,
                                  "item-text": "valor",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Estudios:",
                                  rules: _vm.$validate(["required"])
                                },
                                model: {
                                  value: _vm.form.id_parametro_estudio,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "id_parametro_estudio",
                                      $$v
                                    )
                                  },
                                  expression: "form.id_parametro_estudio"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.instituciones,
                                  "item-text": "nombre_institucion",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Nombre institución:",
                                  rules: _vm.$validate(["required"])
                                },
                                model: {
                                  value: _vm.form.id_institucion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_institucion", $$v)
                                  },
                                  expression: "form.id_institucion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.carreras,
                                  "item-text": "nombre_carrera",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Carrera o área de formación",
                                  rules: _vm.$validate(["required"])
                                },
                                model: {
                                  value: _vm.form.id_carrera,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_carrera", $$v)
                                  },
                                  expression: "form.id_carrera"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Fecha de inicio",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.form.fecha_inicio,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_inicio", $$v)
                                  },
                                  expression: "form.fecha_inicio"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Fecha de conclusión",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.form.fecha_conclusion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_conclusion", $$v)
                                  },
                                  expression: "form.fecha_conclusion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md3: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: {
                                    label: "¿Tiene título?",
                                    rules: [
                                      function(v) {
                                        if (v == null) {
                                          return "El campo es obligatorio."
                                        }
                                        return true
                                      }
                                    ]
                                  },
                                  model: {
                                    value: _vm.form.titulado,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "titulado", $$v)
                                    },
                                    expression: "form.titulado"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Si", value: true }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: { label: "No", value: false }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  this.form.titulado && this.form.id_parametro_estudio != 79
                    ? _c(
                        "v-container",
                        { attrs: { "grid-list-md": "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md9: "" } },
                                [
                                  this.form.titulado != false
                                    ? _c("v-text-field", {
                                        attrs: {
                                          label: "Título obtenido",
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          maxlength: "200"
                                        },
                                        model: {
                                          value: _vm.form.titulo_obtenido,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "titulo_obtenido",
                                              $$v
                                            )
                                          },
                                          expression: "form.titulo_obtenido"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md9: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.profesiones,
                                      "item-text": "nombre_profesion",
                                      "item-value": function(val) {
                                        return parseInt(val.id)
                                      },
                                      label: "Profesión",
                                      rules: _vm.$validate([
                                        "id_parametro_estudio"
                                      ])
                                    },
                                    model: {
                                      value: _vm.form.id_profesion,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "id_profesion", $$v)
                                      },
                                      expression: "form.id_profesion"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md12: "" } }, [
                                _vm._v(" Título académico (TA)")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.form.id_parametro_ta,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "id_parametro_ta",
                                            $$v
                                          )
                                        },
                                        expression: "form.id_parametro_ta"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "Si", value: 31 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "No", value: 32 }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  this.form.id_parametro_ta == 31 ||
                                  this.form.id_parametro_ta == null
                                    ? _c("v-text-field", {
                                        attrs: { label: "Fecha", type: "date" },
                                        model: {
                                          value: _vm.form.fecha_ta,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "fecha_ta", $$v)
                                          },
                                          expression: "form.fecha_ta"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md2: "" } },
                                [
                                  this.form.id_parametro_ta == 31 ||
                                  this.form.id_parametro_ta == null
                                    ? _c("v-text-field", {
                                        attrs: {
                                          type: "number",
                                          label: "Número",
                                          maxlength: "10",
                                          rules: [
                                            function(v) {
                                              if (v > 2147483647) {
                                                return "Valor invalido"
                                              }

                                              if (v < 0) {
                                                return "El campo no puede ser negativo."
                                              }
                                              return true
                                            }
                                          ]
                                        },
                                        model: {
                                          value: _vm.form.numero_ta,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "numero_ta",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "form.numero_ta"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md12: "" } }, [
                                _vm._v(" Título en provisión nacional (TPN) ")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.form.id_parametro_tpn,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "id_parametro_tpn",
                                            $$v
                                          )
                                        },
                                        expression: "form.id_parametro_tpn"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "Si", value: 34 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "No", value: 35 }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  this.form.id_parametro_tpn == 34 ||
                                  this.form.id_parametro_tpn == null
                                    ? _c("v-text-field", {
                                        attrs: { label: "Fecha", type: "date" },
                                        model: {
                                          value: _vm.form.fecha_tpn,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "fecha_tpn", $$v)
                                          },
                                          expression: "form.fecha_tpn"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md2: "" } },
                                [
                                  this.form.id_parametro_tpn == 34 ||
                                  this.form.id_parametro_tpn == null
                                    ? _c("v-text-field", {
                                        attrs: {
                                          type: "number",
                                          label: "Número",
                                          rules: [
                                            function(v) {
                                              if (v > 2147483647) {
                                                return "Valor invalido"
                                              }

                                              if (v < 0) {
                                                return "El campo no puede ser negativo."
                                              }
                                              return true
                                            }
                                          ]
                                        },
                                        model: {
                                          value: _vm.form.numero_tpn,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "numero_tpn",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "form.numero_tpn"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md12: "" } },
                                [
                                  _c("v-flex", [
                                    _c("input", {
                                      ref: "file",
                                      attrs: {
                                        id: "input",
                                        type: "file",
                                        accept: "image/*, application/pdf",
                                        value: "reset"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleFileUpload()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.error
                                      ? _c(
                                          "p",
                                          { staticClass: "red--text body-1" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.mensjageerror) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.form.titulado && this.form.id_parametro_estudio == 79
                    ? _c(
                        "v-container",
                        { attrs: { "grid-list-md": "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md9: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Título obtenido",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      maxlength: "200"
                                    },
                                    model: {
                                      value: _vm.form.titulo_obtenido,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "titulo_obtenido",
                                          $$v
                                        )
                                      },
                                      expression: "form.titulo_obtenido"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md9: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.profesiones,
                                      "item-text": "nombre_profesion",
                                      "item-value": function(val) {
                                        return parseInt(val.id)
                                      },
                                      label: "Profesión",
                                      rules: _vm.$validate(["required"]),
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.form.id_profesion,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "id_profesion", $$v)
                                      },
                                      expression: "form.id_profesion"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md12: "" } }, [
                                _vm._v(" Título académico (TA)")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: {
                                        row: "",
                                        rules: [
                                          function(v) {
                                            if (v == null) {
                                              return "El campo es obligatorio."
                                            }
                                            return true
                                          }
                                        ]
                                      },
                                      model: {
                                        value: _vm.form.id_parametro_ta,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "id_parametro_ta",
                                            $$v
                                          )
                                        },
                                        expression: "form.id_parametro_ta"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "Si", value: 31 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "No", value: 32 }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  this.form.id_parametro_ta == 31 ||
                                  this.form.id_parametro_ta == null
                                    ? _c("v-text-field", {
                                        attrs: {
                                          label: "Fecha",
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          type: "date"
                                        },
                                        model: {
                                          value: _vm.form.fecha_ta,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "fecha_ta", $$v)
                                          },
                                          expression: "form.fecha_ta"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md2: "" } },
                                [
                                  this.form.id_parametro_ta == 31 ||
                                  this.form.id_parametro_ta == null
                                    ? _c("v-text-field", {
                                        attrs: {
                                          type: "number",
                                          label: "Número",
                                          maxlength: "10",
                                          required: "",
                                          rules: [
                                            function(v) {
                                              if (v > 2147483647) {
                                                return "Valor invalido"
                                              }
                                              if (v == null) {
                                                return "El campo es obligatorio."
                                              }
                                              if (v < 0) {
                                                return "El campo no puede ser negativo."
                                              }
                                              return true
                                            }
                                          ]
                                        },
                                        model: {
                                          value: _vm.form.numero_ta,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "numero_ta",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "form.numero_ta"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { md12: "" } }, [
                                _vm._v(" Título en provisión nacional (TPN) ")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.form.id_parametro_tpn,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "id_parametro_tpn",
                                            $$v
                                          )
                                        },
                                        expression: "form.id_parametro_tpn"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "Si", value: 34 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "No", value: 35 }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  this.form.id_parametro_tpn == 34 ||
                                  this.form.id_parametro_tpn == null
                                    ? _c("v-text-field", {
                                        attrs: { label: "Fecha", type: "date" },
                                        model: {
                                          value: _vm.form.fecha_tpn,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "fecha_tpn", $$v)
                                          },
                                          expression: "form.fecha_tpn"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md2: "" } },
                                [
                                  this.form.id_parametro_tpn == 34 ||
                                  this.form.id_parametro_tpn == null
                                    ? _c("v-text-field", {
                                        attrs: {
                                          type: "number",
                                          label: "Número",
                                          rules: [
                                            function(v) {
                                              if (v > 2147483647) {
                                                return "Valor invalido"
                                              }

                                              if (v < 0) {
                                                return "El campo no puede ser negativo."
                                              }
                                              return true
                                            }
                                          ]
                                        },
                                        model: {
                                          value: _vm.form.numero_tpn,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "numero_tpn",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "form.numero_tpn"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md12: "" } },
                                [
                                  _c("v-flex", [
                                    _c("input", {
                                      ref: "file",
                                      attrs: {
                                        id: "input",
                                        type: "file",
                                        accept: "image/*, application/pdf",
                                        value: "reset"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleFileUpload()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.error
                                      ? _c(
                                          "p",
                                          { staticClass: "red--text body-1" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.mensjageerror) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n          "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.save")) + "\n          "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05b8d6b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b8d6b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/dialogs/CrearActualizarFormacionAcademica.vue
// module id = null
// module chunks = 